import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from '../services/token-storage/token-storage.service';
import { Router } from '@angular/router';
import { ApplicationService } from '../services/application.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private tokenStorageService: TokenStorageService,
    private router: Router,
    private applicationService: ApplicationService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq = request;
    const token = this.tokenStorageService.getToken();
    const isApiUrl = request.url.startsWith(environment.apiUrl);
    const isLoginUrl = request.url.startsWith(
      environment.apiUrl + '/auth/signin'
    );
    if (token != null && isApiUrl && !isLoginUrl) {
      authReq = request.clone({
        headers: request.headers.append('Authorization', 'Bearer ' + token),
      });
    }

    return next.handle(authReq).pipe(
      map((event: HttpEvent<any>) => event), // pass further respone
      catchError((error: HttpErrorResponse) => {
        // here will be catched error from response, just check if its 401
        if (error && error.status == 401 && !isLoginUrl) {
          if (
            this.tokenStorageService.getUser() &&
            this.tokenStorageService.getUser().username
          ) {
            if (!this.applicationService.lockScreen$.value) {
              this.applicationService.lockScreen$.next(true);
            }
          } else {
            this.tokenStorageService.signOut();
            this.router.navigate(['/login']);
          }
        } else {
          if (!isLoginUrl) {
            this.applicationService.displayError$.next(true);
            this.applicationService.errorMessage$.next(error.message);
          }
        }
        return throwError(error);
      })
    );
  }
}

export const jwtInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
];
